// T22.146 + T22.139 (Gordon 2026-10-12): every media picker (Segment Fill
// Image/GIF, Portrait, Wallpaper, blocks) shows ONE source-tab strip in ONE
// order, whatever order its caller lists the sources in:
//   Upload · Embed URL · Browse · Preset · Recent
// Sources outside the five (Record, Loops, Media Library, …) follow, in the
// caller's order. Audio's paste-a-link tabs ("Link" / "Embed Code") and the
// wallpaper's legacy "URL" take the Embed URL slot.
export const UNIVERSAL_SOURCE_ORDER = [
  "Upload",
  "Embed URL",
  "Browse",
  "Preset",
  "Recent",
];

const SLOT = {
  Upload: 0,
  "Embed URL": 1,
  URL: 1,
  Link: 1,
  "Embed Code": 1,
  Browse: 2,
  Preset: 3,
  Recent: 4,
};

const slotOf = (category) =>
  Object.prototype.hasOwnProperty.call(SLOT, category)
    ? SLOT[category]
    : UNIVERSAL_SOURCE_ORDER.length;

export const orderSourceTabs = (categories) => {
  if (!Array.isArray(categories)) return categories;
  return categories
    .map((category, index) => ({ category, index }))
    .sort((a, b) => slotOf(a.category) - slotOf(b.category) || a.index - b.index)
    .map(({ category }) => category);
};

// Live 1440 measure (main.36da05d4): the Segment Fill pane gives the strip
// ~314px, the five labels need ~376px at the shared Tabs' 8px 12px padding,
// so "Recent" ran past the pane edge and was clipped ("Re"). Tighter padding
// fits all five on one row in that pane; any narrower pane wraps the strip to a
// second row instead of clipping or hiding tabs behind scroll arrows. The MUI
// sliding indicator cannot follow a wrapped row, so the selected tab draws its
// own underline.
export const SOURCE_STRIP_SX = {
  "& .MuiTabs-flexContainer": {
    flexWrap: "wrap",
    gap: "2px",
  },
  "& .MuiTabs-scroller": {
    overflow: "visible",
  },
  "& .MuiTabs-scrollButtons": {
    display: "none",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTab-root.MuiTab-root": {
    minWidth: 0,
    paddingLeft: "6px",
    paddingRight: "6px",
  },
  "& .MuiTab-root.Mui-selected": {
    boxShadow: "inset 0 -2px 0 #C283DA",
  },
};
